import React from 'react';
import { Menu } from 'antd';
import { NavLink, useRouteMatch } from 'react-router-dom';
import { ReactSVG } from 'react-svg';
import FeatherIcon from 'feather-icons-react';
import propTypes from 'prop-types';

const { SubMenu } = Menu;

const MenuItems = ({ darkMode, toggleCollapsed, topMenu, events }) => {
  const { path } = useRouteMatch();

  const pathName = window.location.pathname;
  const pathArray = pathName.split(path);
  const mainPath = pathArray[1];
  const mainPathSplit = mainPath.split('/');

  const { onRtlChange, onLtrChange, modeChangeDark, modeChangeLight, modeChangeTopNav, modeChangeSideNav } = events;
  const [openKeys, setOpenKeys] = React.useState(
    !topMenu ? [`${mainPathSplit.length > 2 ? mainPathSplit[1] : 'dashboard'}`] : [],
  );

  const onOpenChange = keys => {
    setOpenKeys(keys[keys.length - 1] !== 'recharts' ? [keys.length && keys[keys.length - 1]] : keys);
  };

  const onClick = item => {
    if (item.keyPath.length === 1) setOpenKeys([]);
  };

  return (
    <Menu
      onOpenChange={onOpenChange}
      onClick={onClick}
      mode={!topMenu || window.innerWidth <= 991 ? 'inline' : 'horizontal'}
      theme={darkMode && 'dark'}
      // // eslint-disable-next-line no-nested-ternary
      defaultSelectedKeys={
        !topMenu
          ? [
            `${mainPathSplit.length === 1 ? 'home' : mainPathSplit.length === 2 ? mainPathSplit[1] : mainPathSplit[2]
            }`,
          ]
          : []
      }
      defaultOpenKeys={!topMenu ? [`${mainPathSplit.length > 2 ? mainPathSplit[1] : 'dashboard'}`] : []}
      overflowedIndicator={<FeatherIcon icon="more-vertical" />}
      openKeys={openKeys}
    >
      {!topMenu && <p className="sidebar-nav-title">Administración</p>}
      <Menu.Item
        icon={
          !topMenu && (
            <NavLink className="menuItem-iocn" to={`${path}/sucursales/listado`}>
              <FeatherIcon icon="home" />
            </NavLink>
          )
        }
        key="sucursales"
      >
        <NavLink onClick={toggleCollapsed} to={`${path}/sucursales/listado`}>
          Sucursales
        </NavLink>
      </Menu.Item>

      <Menu.Item
        icon={
          !topMenu && (
            <NavLink className="menuItem-iocn" to={`${path}/servicios/listado`}>
              <FeatherIcon icon="shopping-bag" />
            </NavLink>
          )
        }
        key="servicios-odontologicos"
      >
        <NavLink onClick={toggleCollapsed} to={`${path}/servicios/listado`}>
          Servicios odontologicos
        </NavLink>
      </Menu.Item>

      <Menu.Item
        icon={
          !topMenu && (
            <NavLink className="menuItem-iocn" to={`${path}/productos/listado`}>
              <FeatherIcon icon="shopping-cart" />
            </NavLink>
          )
        }
        key="productos"
      >
        <NavLink onClick={toggleCollapsed} to={`${path}/productos/listado`}>
          Dental Store
        </NavLink>
      </Menu.Item>

      <Menu.Item
        icon={
          !topMenu && (
            <NavLink className="menuItem-iocn" to={`${path}/recursos-humanos/listado`}>
              <FeatherIcon icon="users" />
            </NavLink>
          )
        }
        key="recursos-humanos"
      >
        <NavLink onClick={toggleCollapsed} to={`${path}/recursos-humanos/listado`}>
          Recursos humanos
        </NavLink>
      </Menu.Item>

      <Menu.Item
        icon={
          !topMenu && (
            <NavLink className="menuItem-iocn" to={`${path}/convenios`}>
              <FeatherIcon icon="feather" />
            </NavLink>
          )
        }
        key="convenios"
      >
        <NavLink onClick={toggleCollapsed} to={`${path}/convenios`}>
          Convenios
        </NavLink>
      </Menu.Item>

      {!topMenu && <p className="sidebar-nav-title">Ventas</p>}
      <Menu.Item
        icon={
          !topMenu && (
            <NavLink className="menuItem-iocn" to={`${path}/ventas/configurador-comisiones`}>
              <FeatherIcon icon="dollar-sign" />
            </NavLink>
          )
        }
        key="configurador-comisiones"
      >
        <NavLink onClick={toggleCollapsed} to={`${path}/ventas/configurador-comisiones`}>
          Configurador comisiones
        </NavLink>
      </Menu.Item>
      <Menu.Item
        icon={
          !topMenu && (
            <NavLink className="menuItem-iocn" to={`${path}/ventas/visor-membresias`}>
              <FeatherIcon icon="bookmark" />
            </NavLink>
          )
        }
        key="visor-membresias"
      >
        <NavLink onClick={toggleCollapsed} to={`${path}/ventas/empresas`}>
          Visor de membresías
        </NavLink>
      </Menu.Item>
      <Menu.Item
        icon={
          !topMenu && (
            <NavLink className="menuItem-iocn" to={`${path}/ventas/empresas/listado`}>
              <FeatherIcon icon="briefcase" />
            </NavLink>
          )
        }
        key="empresas"
      >
        <NavLink onClick={toggleCollapsed} to={`${path}/ventas/empresas/listado`}>
          Empresas
        </NavLink>
      </Menu.Item>
      {!topMenu && <p className="sidebar-nav-title">Clínica</p>}
      <Menu.Item
        icon={
          !topMenu && (
            <NavLink className="menuItem-iocn" to={`${path}/clinica/pacientes/listado`}>
              <FeatherIcon icon="users" />
            </NavLink>
          )
        }
        key="clinica/pacientes"
      >
        <NavLink onClick={toggleCollapsed} to={`${path}/clinica/pacientes/listado`}>
          Pacientes
        </NavLink>
      </Menu.Item>
      <Menu.Item
        icon={
          !topMenu && (
            <NavLink className="menuItem-iocn" to={`${path}/clinica/agenda`}>
              <FeatherIcon icon="calendar" />
            </NavLink>
          )
        }
        key="clinica/agenda"
      >
        <NavLink onClick={toggleCollapsed} to={`${path}/clinica/agenda`}>
          Agenda
        </NavLink>
      </Menu.Item>


      <Menu.Item
        icon={
          !topMenu && (
            <NavLink className="menuItem-iocn" to={`${path}/clinica/gastos/listado`}>
              <FeatherIcon icon="folder-minus" />
            </NavLink>
          )
        }
        key="clinica/gastos"
      >
        <NavLink onClick={toggleCollapsed} to={`${path}/clinica/gastos/listado`}>
          Gastos
        </NavLink>
      </Menu.Item>

      <Menu.Item
        icon={
          !topMenu && (
            <NavLink className="menuItem-iocn" to={`${path}/clinica/corte-del-dia`}>
              <FeatherIcon icon="scissors" />
            </NavLink>
          )
        }
        key="clinica/corte-del-dia"
      >
        <NavLink onClick={toggleCollapsed} to={`${path}/clinica/corte-del-dia`}>
          Corte del día
        </NavLink>
      </Menu.Item>


      {!topMenu && <p className="sidebar-nav-title">Configuración</p>}

      <Menu.Item
        icon={
          !topMenu && (
            <NavLink className="menuItem-iocn" to={`${path}/catalogos/categorias-servicios/listado`}>
              <FeatherIcon icon="sliders" />
            </NavLink>
          )
        }
        key="categorias-servicios"
      >
        <NavLink onClick={toggleCollapsed} to={`${path}/catalogos/categorias-servicios/listado`}>
        Categoria de servicios
        </NavLink>
      </Menu.Item>

      <Menu.Item
        icon={
          !topMenu && (
            <NavLink className="menuItem-iocn" to={`${path}/catalogos/tipo-origen-paciente/listado`}>
              <FeatherIcon icon="user-check" />
            </NavLink>
          )
        }
        key="tipo-origen-paciente"
      >
        <NavLink onClick={toggleCollapsed} to={`${path}/catalogos/tipo-origen-paciente/listado`}>
         Tipo origen paciente
        </NavLink>
      </Menu.Item>
      
      <Menu.Item
        icon={
          !topMenu && (
            <NavLink className="menuItem-iocn" to={`${path}/catalogos/clave-descuento/listado`}>
              <FeatherIcon icon="percent" />
            </NavLink>
          )
        }
        key="clave-descuento"
      >
        <NavLink onClick={toggleCollapsed} to={`${path}/catalogos/clave-descuento/listado`}>
        Clave descuento
        </NavLink>
      </Menu.Item>
      
      <Menu.Item
        icon={
          !topMenu && (
            <NavLink className="menuItem-iocn" to={`${path}/catalogos/esquemas-contractuales/listado`}>
              <FeatherIcon icon="list" />
            </NavLink>
          )
        }
        key="esquemas-contractuales"
      >
        <NavLink onClick={toggleCollapsed} to={`${path}/catalogos/esquemas-contractuales/listado`}>
        Esquemas contractuales
        </NavLink>
      </Menu.Item>
      
      {!topMenu && <p className="sidebar-nav-title">Finanzas</p>}

      <Menu.Item
        icon={
          !topMenu && (
            <NavLink className="menuItem-iocn" to={`${path}/finanzas/pagos-registrados/listado`}>
              <FeatherIcon icon="credit-card" />
            </NavLink>
          )
        }
        key="pagos-registrados"
      >
        <NavLink onClick={toggleCollapsed} to={`${path}/finanzas/pagos-registrados/listado`}>
        Pagos registrados
        </NavLink>
      </Menu.Item>

    </Menu>
  );
};

MenuItems.propTypes = {
  darkMode: propTypes.bool,
  topMenu: propTypes.bool,
  toggleCollapsed: propTypes.func,
  events: propTypes.object,
};

export default MenuItems;
